import moment from 'moment';

export default {
  methods: {
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },

    formatDateWithTime(date) {
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },

    formatDateLong(date) {
      return moment(date).format('LL');
    },

    isValidDate(date) {
      return moment(date).isValid();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/date.js